import { Navigate } from 'react-router-dom';

import { useAuthStore, userProfileSelector } from 'modules/auth/core';

import { includes } from 'lodash';

import { PATH } from 'constants/path';

const withPermission =
  (requiredPermissions: string[], redirectPath?: string) =>
  (Component: React.ComponentType) =>
  ({ ...props }) => {
    const userProfile = useAuthStore(userProfileSelector);
    const permissions = userProfile.permission.webs || [];

    if (!userProfile.id) {
      return <Component {...props} />;
    }

    if (
      permissions?.length &&
      permissions.some((permission) => includes(requiredPermissions, permission))
    ) {
      return <Component {...props} />;
    }

    return <Navigate to={redirectPath ?? PATH.ERROR_404} replace />;
  };

export default withPermission;
